import { AWARENESS_BASE_ROUTE } from '@/src/utils/constants'
import React, { Suspense } from 'react'
import type { RouteObject } from 'react-router-dom'
import { LayoutMain } from '../../../layouts/LayoutMain/LayoutMain'
import { AuthRoute } from '../../../routes/routes.components'

const AwarenessTabLazy = React.lazy(() => import('../../Messstellen/AwarenessTab'))

const AwarenessTabScreen = (
  <Suspense fallback={<div></div>}>
    <AwarenessTabLazy />
  </Suspense>
)

export const awarenessRoutes: RouteObject[] = [
  {
    path: `${AWARENESS_BASE_ROUTE}`,
    element: (
      <AuthRoute>
        <LayoutMain />
      </AuthRoute>
    ),
    children: [{ path: '', element: AwarenessTabScreen }],
  },
]
